import { Menu, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext, isFundManager } from '../../contexts/UserContext';
import useSignout from '../../hooks/useSignout';
import { UserToken } from 'types';

function classNames(...classes: string[]) {
   return classes.filter(Boolean).join(' ');
}

export default function PopoverMenu() {
   const signout = useSignout();
   const { user } = useContext(UserContext) as { user: UserToken };

   return (
      <Menu as="div" className="ml-3 relative">
         {({ open }) => (
            <>
               <div>
                  <Menu.Button className="bg-gray-300 flex text-sm rounded-full focus:outline-none ">
                     <span className="sr-only">Open user menu</span>
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-7 w-7 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth={2}
                           d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                     </svg>
                  </Menu.Button>
               </div>
               <Transition
                  show={open}
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
               >
                  <MenuItems
                     static
                     className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                  >
                     <MenuItem>
                        {({ focus }) => (
                           <Link
                              to="/profile"
                              className={classNames(
                                 focus ? 'bg-gray-100' : '',
                                 'block px-4 py-2 text-sm text-gray-700',
                              )}
                           >
                              My Profile
                           </Link>
                        )}
                     </MenuItem>

                     <MenuItem>
                        {({ focus }) => (
                           <Link
                              to="/"
                              className={classNames(
                                 focus ? 'bg-gray-100' : '',
                                 'block sm:hidden px-4 py-2 text-sm text-gray-700',
                              )}
                           >
                              Documents
                           </Link>
                        )}
                     </MenuItem>

                     {user?.hasStatements && (
                        <MenuItem>
                           {({ focus }) => (
                              <Link
                                 to="/investments"
                                 className={classNames(
                                    focus ? 'bg-gray-100' : '',
                                    'block sm:hidden px-4 py-2 text-sm text-gray-700',
                                 )}
                              >
                                 Investments
                              </Link>
                           )}
                        </MenuItem>
                     )}

                     {/*Fund manager requests*/}
                     {isFundManager(user) && (
                        <MenuItem>
                           {({ focus }) => (
                              <Link
                                 to="/requests"
                                 className={classNames(
                                    focus ? 'bg-gray-100' : '',
                                    'block sm:hidden px-4 py-2 text-sm text-gray-700',
                                 )}
                              >
                                 Requests
                              </Link>
                           )}
                        </MenuItem>
                     )}

                     <MenuItem>
                        {({ focus }) => (
                           <Link
                              to="/forms"
                              className={classNames(
                                 focus ? 'bg-gray-100' : '',
                                 'block sm:hidden px-4 py-2 text-sm text-gray-700',
                              )}
                           >
                              Forms
                           </Link>
                        )}
                     </MenuItem>

                     <MenuItem>
                        {({ focus }) => (
                           <Link
                              to="/contact"
                              className={classNames(
                                 focus ? 'bg-gray-100' : '',
                                 'block sm:hidden px-4 py-2 text-sm text-gray-700',
                              )}
                           >
                              Contact Us
                           </Link>
                        )}
                     </MenuItem>

                     <MenuItem>
                        {({ focus }) => (
                           <button
                              onClick={signout}
                              className={classNames(
                                 focus ? 'bg-gray-100' : '',
                                 'text-left block w-full px-4 py-2 text-sm text-gray-700',
                              )}
                           >
                              Sign out
                           </button>
                        )}
                     </MenuItem>
                  </MenuItems>
               </Transition>
            </>
         )}
      </Menu>
   );
}
